export default __webpack_public_path__ + "static/media/Linkedin.05e3ce29.svg";